export default __webpack_public_path__ + "static/media/strategie.8e592a3e.jpg";